const config = {
    getAuthToken: () => localStorage.getItem('authToken')
};

export default config;